import React from 'react'
import {
    OverMap,
    SectionImage,
    SectionTypography,
    SectionImageResponsive,
    SectionTypographyResponsive,
} from './styles'
import { SuccessLabels } from 'src/types'
import {
    TypographyTitle,
    TypographyContent,
} from 'src/components/common/Typography/typography'
import { useAnimation } from 'src/hook'
import { renderButtons } from './renderButtons'

export const MapSuccess = ({
    address,
    firstImage,
    title,
    typography,
    webAndApp,
    animationImage,
    animationText,
    reference,
    referenceApple,
    referencePlay,
    noting,
}: SuccessLabels) => {
    const { control, ref } = useAnimation({ initialSpriteIdTitle: 2 })

    return (
        <OverMap
            address={address}
            paddingTop="xxlarge"
            paddingBottom="xxlarge"
            ref={ref}
        >
            <SectionImage
                src={firstImage}
                alt={title}
                loading="lazy"
                initial="hidden"
                animate={control}
                variants={animationImage}
            />
            <SectionImageResponsive src={firstImage} alt={title} />

            {/* Animación principal */}
            <SectionTypography
                initial="hidden"
                animate={control}
                variants={animationText}
            >
                <TypographyTitle
                    variant="h1"
                    fontSize={['initial', 'initial', 'xxmedium', 'titlle']}
                    fontWeight={600}
                >
                    {title}
                </TypographyTitle>
                <TypographyContent
                    variant="h2"
                    fontSize={['xsmall', 'xsmall', 'xsmall', 'xxsmall']}
                    fontWeight={400}
                >
                    {typography}
                </TypographyContent>
                <br />
                {noting &&
                    renderButtons({
                        referenceApple,
                        referencePlay,
                        reference,
                        webAndApp,
                    })}
            </SectionTypography>

            {/* Responsive sin animación */}
            <SectionTypographyResponsive>
                <TypographyTitle
                    variant="h1"
                    fontSize={['initial', 'initial', 'xxmedium', 'titlle']}
                    fontWeight={600}
                >
                    {title}
                </TypographyTitle>
                <TypographyContent
                    variant="h2"
                    fontSize={['xsmall', 'xsmall', 'xsmall', 'xxsmall']}
                    fontWeight={400}
                >
                    {typography}
                </TypographyContent>
                <br />
                {noting &&
                    renderButtons({
                        referenceApple,
                        referencePlay,
                        reference,
                        webAndApp,
                    })}
            </SectionTypographyResponsive>
        </OverMap>
    )
}
